import React from "react";
import PropTypes from "prop-types";
import {getMediaThumbSrc} from "../../helpers/mediaUrl";


const GalleryForm = (props) => {

  const {
    model,
    formData,
    setFormData,
    name = 'media',
  } = props

  const MAX_IMAGES = 10

  // Current gallery = existing media minus deleted, plus new previews
  const existingMedia = (model && model[name]) || []
  const deleteIds = (model && model.gallery_delete_ids) || []
  const newFiles = (model && model.gallery_new_files) || []

  const visibleExisting = existingMedia.filter(m => !deleteIds.includes(m.id))
  const totalCount = visibleExisting.length + newFiles.length

  const markChanged = () => {
    setFormData(prevFormData => ({
      ...prevFormData,
      model: formData.model,
      isChanged: true,
      isStored: false,
    }))
  }

  const handleUpload = (e) => {
    const file = e.target.files[0]
    if (!file) return
    if (totalCount >= MAX_IMAGES) return

    if (!model.gallery_new_files) {
      model.gallery_new_files = []
    }
    model.gallery_new_files = [...model.gallery_new_files, {file: file, _preview: URL.createObjectURL(file)}]
    markChanged()

    e.target.value = ''
  }

  const handleDeleteExisting = (mediaItem) => {
    if (!model.gallery_delete_ids) {
      model.gallery_delete_ids = []
    }
    model.gallery_delete_ids = [...model.gallery_delete_ids, mediaItem.id]
    markChanged()
  }

  const handleDeleteNew = (index) => {
    const current = model.gallery_new_files || []
    if (current[index] && current[index]._preview) {
      URL.revokeObjectURL(current[index]._preview)
    }
    model.gallery_new_files = current.filter((_, i) => i !== index)
    markChanged()
  }

  return (
    <div className="component-gallery-form">
      <div className="gallery-form-header">
        <span className="gallery-label">Foto's</span>
        <span className="gallery-count">{totalCount} / {MAX_IMAGES}</span>
      </div>

      <div className="gallery-form-grid">
        {visibleExisting.map((mediaItem) => {
          const src = getMediaThumbSrc(mediaItem)
          if (!src) return null
          return (
            <div key={mediaItem.id} className="gallery-form-item">
              <img src={src} alt="Galerij afbeelding" loading="lazy"/>
              <button type="button"
                className="gallery-delete-btn"
                onClick={() => handleDeleteExisting(mediaItem)}
                title="Verwijder"
              >
                &times;
              </button>
            </div>
          )
        })}

        {newFiles.map((item, index) => (
          <div key={'new-' + index} className="gallery-form-item gallery-new">
            <img src={item._preview} alt="Nieuwe foto" loading="lazy"/>
            <button type="button"
              className="gallery-delete-btn"
              onClick={() => handleDeleteNew(index)}
              title="Verwijder"
            >
              &times;
            </button>
          </div>
        ))}

        {totalCount < MAX_IMAGES &&
          <label className="gallery-form-item gallery-upload">
            <div className="upload-content">
              <div className="upload-icon">&#43;</div>
              <p>Foto toevoegen</p>
            </div>
            <input
              type="file"
              accept="image/*"
              onChange={handleUpload}
            />
          </label>
        }
      </div>
    </div>
  )
}

GalleryForm.propTypes = {
  model: PropTypes.object,
  formData: PropTypes.object,
  setFormData: PropTypes.func,
  name: PropTypes.string,
}

export default GalleryForm
